import React, { useEffect } from 'react';
import { ItemPicture, ItemPrice } from '@sbt-web/ui';
import type { AdItem } from '@sbt-web/network/types';
import { useTrackImpression } from '@tools/tracking/useTrackImpression';
import {
  trackCardClick,
  trackCardImpression,
} from '@client/components/Adv/Geoboost/tracking';
import { getTrackingItem } from '@tools/tracking/adsListingImpressionsTracking/buildCardImpressionTrackingData';
import styles from './index.module.scss';

type CardProps = {
  ad: AdItem;
  rank: number;
  searchId: string;
  className?: string;
};

const Card = ({ ad, rank, searchId, className }: CardProps) => {
  const componentRef = React.useRef(null);
  const setComponentRef = useTrackImpression({
    enabled: true,
    track: () => {
      trackCardImpression(getTrackingItem(ad, 'geoboost', searchId, rank));
    },
  });

  useEffect(() => {
    if (componentRef?.current) {
      setComponentRef(componentRef.current);
    }
  }, [setComponentRef, componentRef]);

  return (
    <a
      href={ad.urls.default}
      className={`${styles['card']} ${className}`}
      ref={componentRef}
      onClick={() =>
        trackCardClick(getTrackingItem(ad, 'geoboost', searchId, rank))
      }
    >
      <ItemPicture
        subject={ad.subject}
        categoryID={ad.category.id}
        images={ad.images}
        formats={['108x82', '160x120', '120x120', '121x82']}
        className={styles['thumbnail']}
      />
      <h6 className={`body-text small semibold ${styles['subject']}`}>
        {ad.subject}
      </h6>
      <span className={`caption small ${styles['seller']}`}>
        {ad.advertiser.shopName ?? ad.advertiser.name}
      </span>
      {ad.features['/price'] && (
        <ItemPrice
          classes={[styles['price']]}
          adType={ad.type.key}
          price={Number(ad.features['/price'].values[0].key)}
        />
      )}
    </a>
  );
};

export { Card };
